import { Controller } from "@hotwired/stimulus";

/**
 * Ranking Filter Controller
 *
 * Manages the ranking status filter by updating hidden fields
 * based on the selected value (ranked/non_ranked)
 */
export default class extends Controller {
  static targets = ["rankedField", "nonRankedField", "select"];

  connect() {
    console.log("Ranking filter controller connected");
    console.log("Ranked field:", this.rankedFieldTarget);
    console.log("Non-ranked field:", this.nonRankedFieldTarget);

    // Get the select element
    const select = this.element.querySelector('select');
    console.log("Select element:", select);
  }

  updateFilter(event) {
    // Get the value from the select element
    const select = this.element.querySelector('select');
    const value = select.value;

    console.log("Filter value changed to:", value);

    // Reset both fields
    this.rankedFieldTarget.value = '';
    this.nonRankedFieldTarget.value = '';

    // Set the appropriate field based on selection
    if (value === 'ranked') {
      this.rankedFieldTarget.value = 'true';
      console.log("Set ranked_students to true");
      console.log("Ranked field value:", this.rankedFieldTarget.value);
    } else if (value === 'non_ranked') {
      this.nonRankedFieldTarget.value = 'true';
      console.log("Set non_ranked_students to true");
      console.log("Non-ranked field value:", this.nonRankedFieldTarget.value);
    } else {
      console.log("Reset both fields to empty");
    }
  }
}
